import type { RelationshipsNode } from '../types';
import { GraphItem, ComponentGraphGroup } from '@ardoq/graph';
import { GroupType } from '@ardoq/api-types';
import { SYNTHETIC_NODE_DEFAULTS } from './consts';
import { NODE_RADIUS } from '../consts';
import { CreateRelationshipsNodeArgs } from 'tabview/relationshipDiagrams/types';

export const isGroup = (node: GraphItem): node is ComponentGraphGroup =>
  node.isGroup();

const createNode = ({
  graphNode,
  parent,
  children,
  representationData,
  colorFilterIdsByComponentId,
  contextComponentId,
  typeModelIdByComponentId,
}: CreateRelationshipsNodeArgs): RelationshipsNode => {
  const { id, modelId } = graphNode;
  const label = graphNode.getItemLabels()?.mainLabel ?? graphNode.getLabel();
  const typeModelId = modelId
    ? (typeModelIdByComponentId.get(modelId) ?? null)
    : null;
  const matchingFilterIds = modelId
    ? (colorFilterIdsByComponentId.get(modelId) ?? null)
    : null;

  const node: RelationshipsNode = {
    ...SYNTHETIC_NODE_DEFAULTS,
    isComponent: graphNode.isComponent(),
    isWorkspace: isGroup(graphNode) && graphNode.type === GroupType.WORKSPACE,
    r: children ? SYNTHETIC_NODE_DEFAULTS.r : NODE_RADIUS,
    children: null,
    className: graphNode.getCSS({ useAsBackgroundStyle: true }),
    label,
    subLabel: isGroup(graphNode) ? (graphNode.subLabel ?? null) : null,
    parent,
    representationData,
    modelId: modelId,
    links: null,
    isSynthetic: false,
    id,
    descendantCount: isGroup(graphNode) ? (graphNode.descendantCount ?? 0) : 0,
    isContext: Boolean(contextComponentId && modelId === contextComponentId),
    matchingFilterIds,
    color: graphNode.getCssColorAttributes(),
    typeModelId,
  };
  return node;
};
export { createNode };
